// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3aNHz","inner":"Footer_inner__3Kjbc"};